'use strict';

import React from 'react';

import QuickFilterBase from './QuickFilterBase';
import getSortItems from '../../../utils/sorting';
import { SALE, LANDS } from '../../../consts';

class SaleLands extends QuickFilterBase {
  constructor (props) {
    super(props);

    this.sortItems = getSortItems(SALE, LANDS);
    this.dataSourceItems = props.dictionary.getDataSourceItems(SALE, LANDS);
  }

  render () {
    return (
      <div className='flex flex-between flex-items-center quick-search-sale-lands'>
        <div className='left-side'>
          <div className='btn-group__dropdowns'>
            { this.renderInterval(SALE, LANDS) }
            { this.renderSort(this.sortItems) }
            { this.renderDataSource(this.dataSourceItems) }
          </div>
          { this.renderMyObject() }
        </div>
        <div className='separator' />
        <div className='right-side'>
          { this.renderViewSelect() }
        </div>
      </div>
    );
  }
}

export default SaleLands;



// WEBPACK FOOTER //
// ./src/ui/Search/QuickFilter/SaleLands.jsx